import {
  openDeliveryFunctionNetworkInterfaceCreatePopup,
} from 'data/deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.actions';
import {
  getDeliveryFunctionNetworkInterfaceCreatedId,
} from 'data/deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.selectors';
import {
  DeliveryFunctionNetworkInterface,
} from 'data/deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.types';
import { SipSettingSection } from 'data/sipSetting/sipSetting.types';
import { SipSettingUpdateCallback } from 'data/template/template.types';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FieldUpdateHandlerParam } from 'shared/form';

// eslint-disable-next-line import/prefer-default-export
export function useDialedDigitExtractionServerFieldCreateNewNetworkInterface(
  handleFieldUpdate: SipSettingUpdateCallback,
): [SipSettingUpdateCallback] {
  const idCreated = useSelector(getDeliveryFunctionNetworkInterfaceCreatedId);
  const dispatch = useDispatch();
  const paramRef = useRef<FieldUpdateHandlerParam>();

  useEffect(() => {
    if (idCreated == null || paramRef.current == null) {
      return;
    }

    const param = paramRef.current;
    if (param == null) {
      return;
    }

    paramRef.current = undefined;

    param.value = idCreated;
    // The value label may have been changed in the create dialog, so removing it to avoid confusion
    param.valueLabel = null;

    handleFieldUpdate(param, SipSettingSection.sipInfo);

  }, [idCreated]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFieldCreateNew: SipSettingUpdateCallback = (param) => {
    const netInterface: DeliveryFunctionNetworkInterface = {
      id: '',
      niid: '',
      interface: param.valueLabel,
    }
    dispatch(openDeliveryFunctionNetworkInterfaceCreatePopup(netInterface));
    paramRef.current = param;
  };

  return [handleFieldCreateNew];
}
